import {IsoDate} from "../../pseudo-types/DateTypes";
import {IHttpService} from "angular";
import {CurrentUserService} from "../user/CurrentUserService";

export enum Milestone {
    ACC_OPEN_STARTED = "ACC_OPEN_STARTED",
    PASSED_MARGIN_QUIZ = "PASSED_MARGIN_QUIZ",
    TRADED_TMC = "TRADED_TMC",
    TRADED_OPTION = "TRADED_OPTION",
    TRADED_EQUITY = "TRADED_EQUITY",
    ACCEPTED_BACKTESTING_DISCLAIMER = "ACCEPTED_BACKTESTING_DISCLAIMER"
}

export type UserMilestones = {
    [key in Milestone]: IsoDate
};

export class MilestoneService {
    public static id = "milestoneService";

    /** @ngInject */
    public constructor(private $http: IHttpService,
                       private currentUserService: CurrentUserService) {
    }

    public async userMilestones(): Promise<UserMilestones> {
        const userId = this.currentUserService.userId;

        const response = await this.$http.get<UserMilestones>(`/tradefloor/api/user/${userId}/milestones`);
        const milestones = response.data!;

        return milestones;
    }

    public async completeMilestone(milestone: Milestone, completed: IsoDate | null = null): Promise<void> {
        const userId = this.currentUserService.userId;

        await this.$http.put(`/tradefloor/api/user/${userId}/milestones/${milestone}`, completed);

    }

}
